// djb2 hash of a URL, returned as an 8-char uppercase hex string.
// Used as a deterministic support/reference code for error correlation in Datadog.
export function hashUrlToSupportCode(url: string): string {
  let hash = 5381;
  for (let i = 0; i < url.length; i++) {
    hash = ((hash << 5) + hash + url.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(16).padStart(8, "0").toUpperCase();
}
